import cn from 'classnames';
import { Heading, LayoutContainer, Picture } from '@petsmart-ui/sparky';
import { propsImageItems } from '../../utils/propsImagesItems';
import type { CampaignBannerSmProps } from './types';
import './CampaignBannerSm.scss';

export function CampaignBannerSm({
    header,
    image,
    textColor,
    backgroundColor,
}: CampaignBannerSmProps) {
    const img = image && propsImageItems(image);

    return (
        <LayoutContainer
            data-testid="campaign-banner-sm"
            className={cn('campaign-banner-sm', {
                'campaign-banner-sm__white': textColor === 'White',
            })}
        >
            <div
                className="campaign-banner-sm__content"
                style={{ ...(!image && { backgroundColor }) }}
            >
                {img && (
                    <Picture
                        imgAlt={image.webAltText}
                        imgSrc={img[0]?.srcSet}
                        items={img}
                    />
                )}

                <Heading tagName="h2">{header}</Heading>
            </div>
        </LayoutContainer>
    );
}
